import React from 'react';
import HomeView from '../components/home-view';

export default class Home extends React.Component {
  render() {
    return (
      <div>
        <HomeView />
      </div>
    );
  }
}
